import {CatalogOfferProduct, PurchaseOfferType, PurchaseReceipt} from '@/types';

export type ActivePurchaseStates =
	| 'confirmAuth'
	| 'compatibility'
	| 'entitlement'
	| 'eula'
	| 'checkout'
	| 'download'
	| 'purchaseCompleted'
	| 'error';

export type IdlePurchaseState = 'inactive';

export type PurchaseState = IdlePurchaseState | ActivePurchaseStates;

export enum PurchaseActionType {
	Cancel = 'cancel',
	Next = 'next',
	Reinitialize = 'reinitialize',
	Start = 'start',
	InternalContextSwitch = 'InternalContextSwitch'
}

export interface PurchaseContextState {
	currentStepIndex: number;
	offerId?: string;
	sandboxId?: string;
	productId?: string;
	offerType?: PurchaseOfferType;
}

export interface PurchaseStartPayload {
	offerId: string;
	sandboxId: string;
	productId?: string;
	offerType?: PurchaseOfferType;
}

export type PurchaseReinitializePayload = PurchaseContextState;

export interface PurchaseStepAction<T extends PurchaseActionType = PurchaseActionType> {
	dispatchedBy: number;
	payload?: T extends PurchaseActionType.Start
		? PurchaseStartPayload
		: T extends PurchaseActionType.Reinitialize
			? PurchaseReinitializePayload
			: undefined;
	type: T;
}

export interface PurchaseContextAction {
	type: PurchaseActionType.InternalContextSwitch;
}

export type PurchaseEvent = () => void;

export type PurchaseStartEvent = (payload?: PurchaseStartPayload) => void;

export type PurchaseReinitializeEvent = (payload: PurchaseReinitializePayload) => void;

export type PurchaseActiveActions = {
	[key in ActivePurchaseStates]: {
		cancel: PurchaseEvent;
		next: PurchaseEvent;
	};
};

export type PurchaseIdleActions = {
	[key in IdlePurchaseState]: {
		cancel: PurchaseEvent;
		reinitialize: PurchaseReinitializeEvent;
		start: PurchaseStartEvent;
	};
};

export interface PurchaseContextProps<T extends PurchaseState> {
	actions: T extends ActivePurchaseStates ? PurchaseActiveActions : PurchaseIdleActions;
	offerId: T extends 'inactive' ? undefined : string;
	sandboxId: T extends 'inactive' ? undefined : string;
	productId?: T extends 'inactive' ? undefined : string;
	offerType?: T extends 'inactive' ? undefined : PurchaseOfferType;
	setPurchaseStates: (purchaseStates: PurchaseState[]) => void;
	state: T;
	receipt: PurchaseReceipt | undefined;
	setReceipt: (receipt: PurchaseReceipt | undefined) => void;
	purchasableProducts: CatalogOfferProduct[];
}
